import { gql } from '@apollo/client';
import React from 'react';
import { CarouselPumoModuleFragment } from '../../generated/types/CarouselPumoModuleFragment';
import { useModuleTracking } from '../../hooks/useModuleTracking';
import {
  CarouselPumoModuleSlider,
  CAROUSEL_PUMO_MODULE_SLIDER_FRAGMENT
} from '../CarouselPumoModuleSlider';
import {
  CarouselPumoModuleGrid,
  CAROUSEL_PUMO_MODULE_GRID_FRAGMENT
} from '../CarouselPumoModuleGrid';

export const CAROUSEL_PUMO_MODULE_FRAGMENT = gql`
  fragment CarouselPumoModuleFragment on CarouselPumoModule {
    name
    id
    layoutType
    ...CarouselPumoModuleSliderFragment
    ...CarouselPumoModuleGridFragment
  }
  ${CAROUSEL_PUMO_MODULE_SLIDER_FRAGMENT}
  ${CAROUSEL_PUMO_MODULE_GRID_FRAGMENT}
`;

enum LayoutType {
  Carousel = 1,
  Grid = 2
}

interface Props {
  carouselPumoModule: CarouselPumoModuleFragment;
}

export const CarouselPumoModule: React.FC<Props> = ({ carouselPumoModule }) => {
  const { ref, onClick } = useModuleTracking({
    name: carouselPumoModule.name,
    attachClickHandler: false
  });

  if (carouselPumoModule.layoutType === LayoutType.Grid) {
    return (
      <div ref={ref} className="CarouselPumoModule">
        <CarouselPumoModuleGrid carouselPumoModuleGrid={carouselPumoModule} onClick={onClick} />
      </div>
    );
  }

  return (
    <div ref={ref} className="CarouselPumoModule">
      <CarouselPumoModuleSlider
        carouselPumoModuleSlider={carouselPumoModule}
        moduleName={carouselPumoModule.name}
        onClick={onClick}
      />
    </div>
  );
};
